// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"a4228ce8","453":"997ca642","640":"6aadd053","794":"ffe6b4b1","972":"89809e18"}[chunkId] + ".chunk.js";
};